import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=15128d92&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=ts&"
export * from "./Welcome.vue?vue&type=script&lang=ts&"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=15128d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15128d92",
  null
  
)

export default component.exports